/* Index Page */

import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
import {Hero}from '../../blocks/hero/hero';
import {Tags}from '../shared/Tags';
import Testimonials from '../../blocks/testimonials/testimonials';

$(() => {

    if ($('.js-tags-shuffle').length){
        const tags = new Tags('.js-tags-shuffle');
    }

    const testimonials = new Testimonials('.js-testimonials');

    $('.js-adventages').slick({
        infinite: false,
        dots: false,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.24,
                    slidesToScroll: 1
                }
            }]
    });

    if ($('.l-hero').length){
        const hero = new Hero();
        hero.play();
    }

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__numbers',
        triggerHook: 0.95,
        reverse: false
    })
    .setClassToggle('.l-page__numbers .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.b-advantages',
        triggerHook: 0.95,
        reverse: false
    })
    .setClassToggle('.b-advantages .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__testimonials',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__testimonials .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.b-clients',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.b-clients .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);

});



// WEBPACK FOOTER //
// ./app/scripts/pages/index.js